var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoublechevronLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "8px",
    viewBox: "0 0 9 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / double chevron-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6483333,4.195 C11.9083333,3.935 12.3283333,3.935 12.5883333,4.195 L12.5883333,4.195 L12.6585333,4.27748 C12.8457333,4.5374 12.8223333,4.901 12.5883333,5.135 L12.5883333,5.135 L10.0016667,7.72166667 L12.5816667,10.3083333 C12.8416667,10.5683333 12.8416667,10.9883333 12.5816667,11.2483333 L12.5816667,11.2483333 L12.4991933,11.31854 C12.2393333,11.5058 11.8763333,11.483 11.6483333,11.255 L11.6483333,11.255 L8.58833333,8.195 C8.32833333,7.935 8.32833333,7.515 8.58833333,7.255 L8.58833333,7.255 Z M7.255,4.195 C7.515,3.935 7.935,3.935 8.195,4.195 L8.195,4.195 L8.2652,4.27748 C8.4524,4.5374 8.429,4.901 8.195,5.135 L8.195,5.135 L5.60833333,7.72166667 L8.18833333,10.3083333 C8.44833333,10.5683333 8.44833333,10.9883333 8.18833333,11.2483333 L8.18833333,11.2483333 L8.10586,11.31854 C7.846,11.5058 7.483,11.483 7.255,11.255 L7.255,11.255 L4.195,8.195 C3.935,7.935 3.935,7.515 4.195,7.255 L4.195,7.255 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar-/-Open-/-01-Add-Notes",
    transform: "translate(-193.000000, -419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(189.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#848484",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublechevronLeft);
export default __webpack_public_path__ + "static/media/double chevron-left.3be2e446f08e92a4b5e54c64e1023dc5.svg";
export { ForwardRef as ReactComponent };